<template>
  <div>
    <JobDetails :job="report" />
    <h2>Reports</h2>
    <v-row>
      <v-col
        lg="6"
        md="6"
        sm="12"
        v-for="report in report.reports"
        :key="report.id"
      >
        <ReportDetailsCard :report="report" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ReportDetailsCard from '../Reporter/ReportDetailsCard.vue'
import JobDetails from './JobDetails.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    ReportDetailsCard,
    JobDetails
  },
  data: () => ({}),
  created() {
    this.getReportedJobDetails(this.$route.params.id)
  },
  computed: {
    ...mapState({
      report: state => state.reportedJob.reportedJobDetails
    })
  },
  methods: {
    ...mapActions({
      getReportedJobDetails: 'reportedJob/getReportedJobDetails'
    })
  }
}
</script>
